var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1038.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Ok",
    transform: "translate(1206.000000, 1038.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9918496,18.9520033 L22.9498475,20.004003 L20.8047402,21.6880026 C20.6857343,21.7650026 20.7317366,21.8100026 20.5787289,21.8100026 C20.1577079,21.8100026 19.9976999,21.4670027 19.9976999,21.0420028 L19.9976999,15.5120042 L21.6647832,13.4270047 L23.6708835,15.2520043 C24.1879094,15.7030041 24.880944,15.6470042 25.3299665,15.1270043 C25.7789889,14.6050044 25.6779839,13.8170046 25.1589579,13.3650047 L23.6718836,12.0150051 L21.620781,10.1370056 C21.2857643,9.82800563 20.7757388,9.79900564 20.4077204,10.0650056 L17.1615581,13.0940048 L16.7935397,1.09000786 C16.7915396,0.476008012 16.2955148,0 15.6864843,0 C15.0744537,-0.001991867 14.5814291,0.36500804 14.580429,0.980007883 L14.2124106,13 L13.1063553,13 L12.7893395,3.55100723 C12.7903395,2.91900739 12.2783139,2.4750075 11.6482824,2.4750075 C11.0182509,2.4760075 10.5072254,3.02500736 10.5072254,3.6580072 L10.1882094,13.3120047 C9.78018901,13.3650047 9.38516926,13.4700047 9.01515076,13.6120047 L8.75913796,8.16400606 C8.76513826,7.52700622 8.25511276,7.01700635 7.6220811,7.02300635 C6.9860493,7.02800635 6.46902345,7.54900621 6.4660233,8.18700605 L6,24.6340019 C6,25.0190018 6.05700285,25.3910017 6.1540077,25.7470016 C6.4300215,27.2110012 7.1340567,28.6100009 8.26111306,29.7440006 C11.2532627,32.7519998 15.979499,32.7519998 18.9716486,29.7440006 L25.559978,22.0850025 C25.7629881,21.8790026 26,21.7720026 26,21.4820027 L26,16.327004 C24.99995,16.327004 22.9878494,17.0030038 22.9918496,18.9520033",
    id: 215
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonOk);
export default __webpack_public_path__ + "static/media/common-ok.2f62d90b.svg";
export { ForwardRef as ReactComponent };